// ANCHOR GraphQL
import { Form_Question_Types_Enum as QuestionType } from '@lyon/graphql/types';

export const QUESTION_TYPES: { [key in QuestionType]: string } = {
  [QuestionType.MultipleChoice]: 'Multiple Choice',
  [QuestionType.CheckboxAnswer]: 'Checkbox Question',
  [QuestionType.ShortAnswer]: 'Short Answer',
  [QuestionType.Essay]: 'Essay/Long Answer',
  [QuestionType.Attachment]: 'Attachment Upload',
  [QuestionType.Spacer]: 'Spacer',
  // FIXME
  [QuestionType.CheckboxAnswer]: 'Checkbox Answer',
};
